var exports = {
  "k": "x93eb46d8--52b305--container",
};

module.exports = exports;
